import {AbstractService} from 'services/AbstractService';

const CURRENT_USER_DETAILS_URL = '/api/seller/me';
const AUTH_USER_URL = '/api/seller/auth';
const GET_BACKWARD_URL = '/api/seller/backward';
const CURRENT_USER_META_URL = '/api/seller/cabinet';
const FETCH_USER_LIST_URL = '/api/seller/impersonation/users';

export class UserSellerService extends AbstractService {
  getCurrentUser () {
    return this.client.get(CURRENT_USER_DETAILS_URL);
  }

  getBackward () {
    return this.client.get(GET_BACKWARD_URL);
  }

  authUser (payload) {
    return this.client.get(AUTH_USER_URL, payload);
  }

  setMeta (payload) {
    return this.client.patch(CURRENT_USER_META_URL, {meta: payload});
  }

  setMetaProject (payload) {
    return this.client.patch(CURRENT_USER_META_URL, {meta: payload, apply_to_account: true});
  }

  getMeta () {
    return this.client.get(CURRENT_USER_META_URL);
  }

  getUserList (params) {
    return this.client.get(FETCH_USER_LIST_URL, params);
  }
}
